/** The Intel extras' words and section orders (`intel.json`, Zod-validated; W4 card C5). */
import { z } from 'zod'
import intelJson from './intel.json'

const text = z.string().min(1)
/** A count's singular and plural ("1 system", "{n} systems"). */
const count = z.strictObject({ one: text, many: text })

export const intelConfigSchema = z.strictObject({
  comment: z.string(),
  /** Order in the Intel tab: after Wire (10) and Charter (20). */
  order: z.strictObject({ markets: z.number().gt(20), stations: z.number().gt(20), charts: z.number().gt(20) }),
  sections: z.strictObject({ markets: text, stations: text, charts: text }),
  noCareer: text,
  liveHere: text,
  markets: z.strictObject({
    empty: text,
    logged: text,
    loggedNote: text,
    wares: count,
    shocks: count,
    ware: text,
    buy: text,
    sell: text,
    stock: text,
    none: text,
    at: text,
  }),
  stations: z.strictObject({
    empty: text,
    notRecorded: text,
    loading: text,
    production: text,
    noLines: text,
    station: text,
    workforce: text,
    habitat: text,
    shipyard: text,
    noOrders: text,
  }),
  charts: z.strictObject({ empty: text, total: text, systems: count, first: text, buyer: text, sell: text }),
})

export type IntelConfig = z.infer<typeof intelConfigSchema>

let cached: IntelConfig | null = null

export function loadIntelConfig(): IntelConfig {
  cached ??= intelConfigSchema.parse(intelJson)
  return cached
}
